<style lang="scss" scoped>
@import 'common/sass/reuse.SCSS';
</style>

<template>
  <div class="maintenance-box">
    <div :element-loading-text="loadText" class="panel" v-loading="loading">
      <custom-table
        :downloadLoading="downloadLoading"
        :downLoadTran="downLoadTran"
        :jsonExcelAjax="jsonExcelAjax"
        :name="name"
        :page="page"
        :selPage="selPage"
        :tableHead="tableHead"
        :tbodyData="tbodyData"
        @tableChange="ajaxHandle"
      >
        <div class="search-box" slot="search">
          <div class="select-type" style="margin-top: 2px;">
            <el-switch :active-text="reuse.moreSelect" inactive-text v-model="more"></el-switch>
          </div>
          <div class="select-type">
            <span v-text="language.timeText"></span>
            <el-date-picker
              :end-placeholder="reuse.endTime"
              :picker-options="pickerOption"
              :start-placeholder="reuse.startTime"
              @blur="blurHandle"
              style="width:220px;"
              type="daterange"
              unlink-panels
              v-model="formData.closeTime"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </div>
          <div class="select-type">
            <span v-text="reuse.loginText"></span>
            <el-input clearable style="width:210px;" v-model="formData.login"></el-input>
          </div>
          <div class="select-type">
            <span v-text="reuse.groupText"></span>
            <el-input clearable style="width:210px;" v-model="formData.group"></el-input>
          </div>
          <div class="select-type">
            <el-button @click="filterHandle" type="primary" v-text="reuse.searchText"></el-button>
          </div>
        </div>
        <div class="extraSearch" slot="more-filters" v-show="more">
          <div class="searchDiv">
            <span v-text="reuse.ibNumText"></span>
            <el-input clearable style="width:210px;" v-model="formData.ibNum"></el-input>
          </div>
          <div class="searchDiv">
            <span v-text="reuse.officeText"></span>
            <el-input clearable style="width:210px;" v-model="formData.office"></el-input>
          </div>
          <div class="searchDiv">
            <span v-text="reuse.regionText"></span>
            <el-input clearable style="width: 210px;" v-model="formData.region"></el-input>
          </div>
          <div class="searchDiv">
            <span v-text="reuse.nameFilterText"></span>
            <el-input clearable style="width:210px;" v-model="formData.nameFilter"></el-input>
          </div>
          <div class="searchDiv">
            <span v-text="reuse.loginFilterText"></span>
            <el-input clearable style="width:210px;" v-model="formData.loginFilter"></el-input>
          </div>
        </div>
      </custom-table>
    </div>
  </div>
</template>

<script>
import customTable from 'components/reuseTable'
import { URL_SUMMARY_REPORT } from 'api/api'
import { days } from 'api/env'
import { onPick, disableDate } from 'common/js/util'

const data = () => {
  return {
    tbodyData: [],
    loading: false,
    downloadLoading: true,
    loadText: '',
    more: false,
    formData: {
      closeTime: [],
      login: null,
      group: null,
      ibNum: null,
      office: null,
      region: null,
      nameFilter: null,
      loginFilter: null
    },
    page: {
      active: 1,
      pageLeng: 0,
      offset: 0
    },
    selPage: {
      list: ['5', '10', '25', '50'],
      active: 1,
      limit: 10
    },
    pickerOption: {
      disabledDate: disableDate,
      onPick: onPick
    }
  }
}

const mixins = [require('common/mixin/base').base({ language: 'mt4SummaryReport' }), require('common/mixin/base').base({ reuse: 'reuse' })]

const computed = {
  name() {
    const closeTime = this.formData.closeTime
    return `${this.language.downloadName}_${closeTime ? closeTime.map(v => v.replace(/-/g, '')).join('-') : ''}`
  },
  tableHead() {
    const redColorColumns = ['DEPOSIT','WITHDRAWL','INOUT','CREDIT','COMMISSION','TAXES','AGENT','SWAPS','PROFIT','BALANCE']
    this.language.tableHead.forEach(head => {
        if(redColorColumns.includes(head.key)) head.redColor = true;
    })
    return this.language.tableHead
  },
  downLoadTran() {
    return {
      loadText: this.language.loadText
    }
  },
  jsonExcelAjax() {
    return {
      url: URL_SUMMARY_REPORT,
      ajaxType: 'post',
      getKey: ['data', 'data', 'data'],
      ajaxPar: {
        ...this.formData,
        pageSize: -1,
        pageNum: 0
      }
    }
  }
}

const created = function() {
  const defaultEnd = this.$moment().format('YYYY-MM-DD')
  const defaultStart = this.$moment()
    .subtract(days, 'd')
    .format('YYYY-MM-DD')
  this.formData.closeTime.push(defaultStart)
  this.formData.closeTime.push(defaultEnd)
  this.ajaxHandle()
}

const methods = {
  filterHandle() {
    this.page.active = 1
    this.ajaxHandle()
  },
  ajaxHandle() {
    this.loading = true
    this.formData.pageNum = this.page.active
    this.formData.pageSize = this.selPage.limit
    this.$http
      .post(URL_SUMMARY_REPORT, this.formData)
      .then(res => {
        if (Object.prototype.toString.call(res.data.data.data) === '[object Array]') {
          this.page.pageLeng = res.data.data.count
          this.tbodyData = res.data.data.data
          this.tbodyData.forEach(v => {
            v.Value_TIME = v.CLOSE_TIME ? this.$moment(v.CLOSE_TIME).format('YYYY.MM.DD') : ''
          })
        } else {
          this.tbodyData = []
          this.page.pageLeng = 0
        }
        if (res.data.msg !== 'OK') this.$message.error(this.reuse.invalidParam)
        this.loading = false
      })
      .catch(e => {
        alert(this.reuse.serverError)
      })
  },
  blurHandle(obj) {
    this.pickerOption.disabledDate = function(time) {
      return time.getTime() > new Date()
    }
  }
}

const components = {
  customTable
}

export default {
  data,
  mixins,
  computed,
  created,
  methods,
  components
}
</script>


// WEBPACK FOOTER //
// src/views/manager-report/mt4-summary-report.vue